import { TinyEmitter } from "@expert/event-bus";

import type { GaiaWebSocketEventType, GaiaWebSocketResponse } from "./types";

export const GAIA_WS_EMITTER_NAME = "gaia_ws";
export type GaiaWsEvents = Record<`${typeof GAIA_WS_EMITTER_NAME}_${GaiaWebSocketEventType}`, GaiaWebSocketResponse>;
export type GaiaWsEventName = keyof GaiaWsEvents;

export const gaiaWsEventBus = new TinyEmitter<GaiaWsEvents>(GAIA_WS_EMITTER_NAME, false);
